module.exports = __webpack_public_path__ + "static/twitter-card-e91c0de2a7927d0d13f980048758ea41.png";